import { mainColor, white } from "assets/styleUtils";
import { TextSection } from "components/TextSection";
import React from "react";

interface Props {
  content: string;
  button?: {
    text: string;
    move?: string;
    onClick?: () => void;
  };
}

export default function EmptyView({ content, button }: Props) {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <img src="/images/alertCircle.png" />
      <div
        style={{
          lineHeight: "24px",
          textAlign: "center",
          fontSize: "16px",
          margin: "16px",
          fontWeight: "500",
        }}
      >
        <TextSection data={content} />
      </div>
      {button &&
        (!!button.onClick ? (
          <div
            style={{
              padding: "11.5px 16px",
              backgroundColor: mainColor,
              borderRadius: "4px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={button.onClick}
          >
            <div
              style={{
                lineHeight: "21px",
                color: white,
              }}
            >
              {button.text}
            </div>
          </div>
        ) : (
          <a
            style={{
              padding: "11.5px 16px",
              backgroundColor: mainColor,
              borderRadius: "4px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
            href={button.move}
          >
            <div
              style={{
                lineHeight: "21px",
                color: white,
              }}
            >
              {button.text}
            </div>
          </a>
        ))}
    </div>
  );
}
